// extracted by mini-css-extract-plugin
export default {"linkDiv":"links_linkDiv__66PZE","linkDivHolder":"links_linkDivHolder__Q5MKP","center":"links_center__V-5ZN","myColor":"links_myColor__3KIkt"};